const clientManagementPageStyle = {
  root: {
    flexGrow: 1,
    display: 'flex',
    height: '100%',
  },
  componentPanel: {
    marginRight: '100px',
    width: '250px',
  },
}

export default clientManagementPageStyle
